import { Pipe } from '@angular/core';
import { DecimalPipe } from "@angular/common";

@Pipe({
    name: 'pointReplacer'
})

export class PointReplacerPipe extends DecimalPipe {

	transform(value: any, digits?: string): string {
		var data: string = super.transform(value, digits).replace(/,|\./g, '|');
		let split: Array<any> = data.split('|');
		data = '';
		for(let count = 0; count < split.length; count++)
			data += split[count] + ((count == split.length - 2) ? ',' : (count != split.length - 1) ? '.' : '');

		return data;
	}
}


// WEBPACK FOOTER //
// ./src/app/pipes/point-replacer.pipe.ts